<template>
  <div class="wrapper-page user-profile">
    <div class="account-settings-menu">
      <h2>{{ $t('account_settings.header_title')}}</h2>
      <div aria-orientation="vertical" role="tablist" class="nav flex-column nav-pills">
        <a href="#user-profile" class="nav-link active" data-toggle="pill" role="tab" aria-selected="true" aria-controls="user-profile" id="user-profile-tab">
          {{$t('account_settings.user_profile')}}
          <div class="white-arrow"></div></a>
        <a   v-show="isCurrentUserAdmin" href="#company" class="nav-link" data-toggle="pill" role="tab" aria-selected="true" aria-controls="company" id="company-tab">
          {{$t('account_settings.manage_users')}}
          <div class="white-arrow"></div></a>

      </div>
      <div class="storage-bar-wrapper">
        <i class="fas fa-cloud"></i>
        <div class="storage">
          <h6>{{$t('account_settings.storage')}}
          <a
            data-zip=""
            data-toggle="tooltip" title="" href="" class="fas fa-download download-all-files"
            data-original-title="Download all my files">
          </a></h6>
          <div class="progress-bar-wrapper">
            <div class="progress-bar" style="width: 2.8%;"></div>
          </div>

          <div class="storage-box">
            <p class="align-left">
              {{$t('account_settings.active_files')}}
            </p>
            <p class="align-right">
              {{currentUploadsCount}}
            </p>
            <p class="align-left">
              {{$t('account_settings.deleted_files')}}
            </p>
            <p class="align-right">
              {{currentDeletedCount}}
            </p>
          </div>
          <div class="total">
            <p class="align-left">
              {{$t('account_settings.total')}}
            </p>
            <p class="align-right">
              {{totalCount}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content" id="v-pills-tabContent">
      <user-profile ref="userProfile"/>
      <company ref="company"/>
    </div>
  </div>
</template>
<script>
  import _userProfile from "../components/account_settings/_user-profile";
  import _company from "../components/account_settings/_company";
  import _userActivity from "../components/account_settings/_user_activity";

  export default {
    components: {
      'user-profile': _userProfile,
      'company': _company,
      'user-activity': _userActivity,
    },
    created() {
      this.store.getCurrentOrg()
      this.store.getStorageQuotas()
      this.store.sendMetrics({name: 'account_settings', params: this.$route.params, path: this.$route.fullPath})
    },
    computed: {
      currentUploadsCount() {
        return this.state.current_uploads_count || 0
      },
      currentDeletedCount() {
        return this.state.current_deleted_count || 0
      },
      totalCount() {
        return this.currentUploadsCount + this.currentDeletedCount
      },
      isCurrentUserAdmin() {
        return this.currentUser.role === 'admin'
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../styles/user_profile"
</style>
